import { render, staticRenderFns } from "./ListAsetDitingkatkanPage.vue?vue&type=template&id=c17977c0"
import script from "./ListAsetDitingkatkanPage.vue?vue&type=script&lang=js"
export * from "./ListAsetDitingkatkanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports